/**
 * <s-before-after> — before/after comparison slider.
 * The inner range input (0–100) sets --ba on the element; CSS clips the
 * "before" photo and positions the divider from that custom property.
 */
class SBeforeAfter extends HTMLElement {
  #ac;

  connectedCallback() {
    const range = this.querySelector('input[type="range"]');
    if (!range) return;

    this.#ac = new AbortController();
    const update = () => this.style.setProperty('--ba', `${range.value}%`);
    range.addEventListener('input', update, { signal: this.#ac.signal });
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-before-after')) {
  customElements.define('s-before-after', SBeforeAfter);
}
